exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#likesBCK{background-color:#000;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden!important}.arrowPOS{position:absolute!important;top:0;left:0}.thumbSize{font-size:12em!important;-webkit-text-stroke:8px #fff}.likeColor{color:green!important}.dislikeColor{color:red!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76150263","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Likes.vue
// module id = 647
// module chunks = 0